
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageOpoznijZadanie(draggedId,dropDate,refreshGantAll) {

// id = procesor id
// console.log(" dropDate: "+dropDate)
  
  axios
  .get(IP + "API_0005_gant_procedura_opoznij_zadanie/"+draggedId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })


}


